// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function TaxReportingIntro(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: "Cервис автоматической сдачи налоговой отчетности",
        className: "h3 lg:h1 text-center lg:flex lg:m-auto lg:w-252 text-white"
      }),
      JsxRuntime.jsx("p", {
        children: "Просто ведите все документы в Бухте и мы автоматическии заполним, согласуем с вами и отправим налоговую отчетность.",
        className: "paragraph-large lg:h5 text-center lg:flex lg:m-auto mt-4 lg:mt-6 lg:w-252 text-white"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          deviceType === "mobile" || deviceType === "tablet" ? null : JsxRuntime.jsx("img", {
              className: "w-132.5 h-57.5 absolute top-13 left-63",
              alt: "chain",
              src: StaticAsset.src("/static/images/chain.png")
            }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "mt-8 lg:mt-0 w-72.5 max-w-none h-67 flex m-auto lg:block",
                alt: "cheque esf",
                src: StaticAsset.src("/static/images/cheque-esf.png")
              }),
              JsxRuntime.jsx("h4", {
                children: "Чеки/ЭСФ/АВР",
                className: "h4 text-center text-white mt-4"
              }),
              JsxRuntime.jsx("p", {
                children: "Все ваши документы для контрагентов будут учтены в отчетности.",
                className: "paragraph text-center text-white opacity-40 mt-2"
              })
            ],
            className: "lg:w-66.5"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-66 lg:w-66.5 lg:h-66.5 flex m-auto mt-8 lg:block lg:m-0",
                alt: "reporting",
                src: StaticAsset.src("/static/images/reporting.png")
              }),
              JsxRuntime.jsx("h4", {
                children: "Отчетность",
                className: "h4 text-center text-white mt-4"
              }),
              JsxRuntime.jsx("p", {
                children: "Мы все сделаем правильно с учетом последних изменений налогового законодательства.",
                className: "paragraph text-center text-white opacity-40 mt-2"
              })
            ],
            className: "lg:w-66.5"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-66 lg:w-66.5 lg:h-66.5 flex m-auto mt-8 lg:block lg:m-0",
                alt: "tax office",
                src: StaticAsset.src("/static/images/tax-office.png")
              }),
              JsxRuntime.jsx("h4", {
                children: "Налоговая",
                className: "h4 text-center text-white mt-4"
              }),
              JsxRuntime.jsx("p", {
                children: "Минимизируйте общение с налоговыми органами. Спите еще спокойнее.",
                className: "paragraph text-center text-white opacity-40 mt-2"
              })
            ],
            className: "lg:w-66.5"
          })
        ],
        className: "lg:flex lg:m-auto mt-8 lg:mt-30 justify-between relative lg:w-252"
      }),
      JsxRuntime.jsx("hr", {
        className: "lg:flex lg:m-auto mt-8 lg:mt-36 lg:w-200 opacity-8 text-white"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            alt: "check green white",
            src: StaticAsset.src("/static/icons/check-green-white.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Больше не нужно гадать - включать ли что-то в отчетность или нет.",
            className: "paragraph-small lg:paragraph-large text-white ml-2"
          })
        ],
        className: "flex m-auto lg:w-200 mt-8 lg:mt-20 items-start"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            alt: "check green white",
            src: StaticAsset.src("/static/icons/check-green-white.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Напомним о сдаче, заполним отчетность,  вам нужно лишь нажать кнопку отправить.",
            className: "paragraph-small lg:paragraph-large text-white ml-2"
          })
        ],
        className: "flex m-auto lg:w-200 mt-4 lg:mt-2 items-start"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            alt: "check green white",
            src: StaticAsset.src("/static/icons/check-green-white.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Рассчитаем налоги и поможем вам оплатить их.",
            className: "paragraph-small lg:paragraph-large text-white ml-2"
          })
        ],
        className: "flex m-auto lg:w-200 mt-4 lg:mt-2 items-start"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            alt: "check green white",
            src: StaticAsset.src("/static/icons/check-green-white.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Вся отчетность хранится в Бухте и в любой момент можете ее просмотреть.",
            className: "paragraph-small lg:paragraph-large text-white ml-2"
          })
        ],
        className: "flex m-auto lg:w-200 mt-4 lg:mt-2 items-start"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            alt: "check green white",
            src: StaticAsset.src("/static/icons/check-green-white.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Все данные по отчетности от кассы до счетов-фактур в Бухте.",
            className: "paragraph-small lg:paragraph-large text-white ml-2"
          })
        ],
        className: "flex m-auto lg:w-200 mt-4 lg:mt-2 items-start"
      })
    ],
    className: "bg-black-landing py-16 lg:py-40 px-6 sm:px-48 lg:px-0"
  });
}

const make = TaxReportingIntro;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
